export const id = {
  title: 'Potensi akumulasi karbon dari pertumbuhan kembali hutan secara alami di area yang dapat dihutankan kembali',
  subtitle: 'reforestable areas, 1 km, Cook-Patton et al. 2020',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Fungsi',
      value:
        'Memperkirakan tingkat penyerapan karbon dalam biomassa hidup di atas permukaan tanah selama tiga puluh tahun pertama pertumbuhan kembali hutan alam di daerah yang berpotensi untuk dihutankan kembali (Mg karbon/ha/tahun).',
    },
    {
      label: 'Resolusi',
      value: '1 × 1 km',
    },
    {
      label: 'Cakupan geografis',
      value:
        'Global, dalam jangkauan penghutanan kembali Griscom et al. 2017 (tidak termasuk boreal, bioma berumput, dan lahan pertanian pangan)',
    },
    {
      label: 'Sumber',
      value:
        'Cook-Patton, S.C., S.M. Leavitt, D. Gibbs, N.L. Harris, K. Lister, K.J. Anderson-Teixeira, R.D. Briggs, R.L. Chazdon, T.W. Crowther, P.W. Ellis, H.P. Griscom, V. Herrmann, K.D. Holl, R.A. Houghton, C. Larrosa, G. Lomax, R. Lucas, P. Madsen, Y. Malhi, A. Paquette, J.D. Parker, K. Paul, D. Routh, S. Roxburgh, S. Saatchi, J.van den Hoogen, W.S. Walker, C.E. Wheeler, S.A. Wood, L. Xu, B.W. Griscom. 2020. Mapping carbon accumulation potential from natural forest regrowth. Nature, in press. https://www.nature.com/articles/s41586-020-2686-x. This work resulted from a collaboration between The Nature Conservancy, World Resources Institute, and 18 other institutions.',
    },
    {
      label: 'Frekuensi pembaruan',
      value: '',
    },
    {
      label: 'Tanggal konten',
      value: 'Berlaku untuk 30 tahun pertama pertumbuhan kembali hutan alam.',
    },
    {
      label: 'Peringatan',
      value:
        '- Nilai mencerminkn perkiraan terbaik tetapi mengandung ketidakpastian. Akurasi hasil bergantung pada ketersediaan data untuk pelatihan model, yang terkonsentrasi di sepuluh negara. Peta ketidakpastian yang terkait dengan lapisan data ini dapat diunduh dari Portal Data Terbuka GFW.\n- Tingkat akumulasi karbon hanya berlaku untuk pertumbuhan kembali hutan alam, dan tidak berlaku untuk metode restorasi aktif lainnya (agroforestri, perkebunan, dll.).\n- Laju akumulasi karbon bersifat linier dan dirata-ratakan selama 30 tahun pertama pertumbuhan kembali. Memperpanjang lebih dari 30 tahun akan melebih-lebihkan penyerapan.\n- Laju ini hanya mencerminkan akumulasi karbon dalam biomassa hidup di atas permukaan tanah saja. Akumulasi dalam biomassa bawah tanah, bahan organik mati, dan karbon organik tanah tidak disertakan tetapi peta akumulasi karbon bawah tanah tersedia berdasarkan permintaan.\n- Di sabana, tingkat ini hanya berlaku untuk bagian berhutan dari matrik padang rumput-hutan ini.\n- Data ini bukan pengganti untuk asesmen rinci tingkat lokasi tentang potensi pertumbuhan kembali hutan.',
    },
    {
      label: 'Lisensi',
      value: 'CC 4.0',
    },
  ],
  overview: {
    label: 'Ikhtisar',
    value:
      'Peta ini menunjukkan tingkat seberapa banyak hutan dapat menyerap karbon dari atmosfer dan menyimpannya di biomassa hidup di atas tanah selama 30 tahun pertama pertumbuhan kembali hutan secara alami. Peta ini dibuat dengan menggabungkan pengukuran berbasis darat di ribuan lokasi di seluruh dunia dengan 66 lapisan kovarian lingkungan berlokasi sama di sebuah model pemelajaran mesin untuk menghasilkan peta yang sangat luas. Data plot hutan yang digunakan untuk melatih model bersumber dari literatur yang telah diterbitkan, yang dapat ditemukan di basis data Forest Carbon (ForC, dikelola oleh Smithsonian Institute (https://github.com/forc-db)), serta data georeferensi dari inventaris nasional hutan yang tersedia untuk publik. Meski tingkatnya diestimasi dari semua bioma hutan dan sabana secara global, mereka juga disaring oleh area yang "dapat dihutankan kembali", seperti yang dicontohkan Griscom et al. 2017 (PNAS). Area yang dapat dihutankan kembali tidak termasuk lahan rerumputan dan lahan pertanian asli demi menjaga produksi makanan, baju, serta habitat keanekaragaman hayati.\n',
  },
  citation: {
    label: 'Rujukan',
    value:
      'Cook-Patton et al. 2020. Carbon accumulation potential from natural forest regrowth in potentially reforestable areas. Accessed through Global Forest Watch 14/02/2025. www.globalforestwatch.org',
  },
};
